<template>
  <div class="rn-root">

    <div class="rn-header">
      <div class="rn-header-left">
        <div class="rn-header-icon">
          <i class="fas fa-poll"></i>
        </div>
        <div>
          <h3 class="rn-title">Relatório de NPS</h3>
          <p class="rn-subtitle">Pesquisa de satisfação</p>
        </div>
      </div>
      <div class="rn-date-range">
        <label class="rn-date-label">De</label>
        <input class="rn-date-input" type="date" v-model="dateStart" />
        <label class="rn-date-label">Até</label>
        <input class="rn-date-input" type="date" v-model="dateEnd" />
      </div>
      <div class="sc-filter-group sc-filter-group--refresh">
        <label class="sc-filter-label">&nbsp;</label>
        <button type="button" class="sc-refresh-btn"
          :class="{ 'sc-refresh-btn--spinning': refreshing }" title="Atualizar relatório" @click="refreshReport">
          <i class="fas fa-sync-alt"></i>
          Atualizar
        </button>
      </div>
    </div>


    <nps-survey-dashboard :key="refreshKey" :filters="filters" />

  </div>
</template>

<script>
import NpsSurveyDashboard from '../reports/NpsSurveyDashboard.vue';
import moment from 'moment';

export default {
  name: 'RelNps',
  components: { NpsSurveyDashboard },
  // Recebido para manter a mesma assinatura de prop dos demais relatórios
  // (RelLog.vue/RelAnalitico.vue), mesmo que o NPS não use filtro por
  // campanha hoje — evita quebrar o <component :is="rel" :filter="..."/>
  // do componente pai (Relatorios.vue).
  props: { filter: { type: Array, default: function () { return []; } } },
  data() {
    return {
      dateStart: moment().format('YYYY-MM-01'),
      dateEnd: moment().format('YYYY-MM-DD'),
      // Força o NpsSurveyDashboard a remontar (e refazer as chamadas de
      // fetch no seu created()) quando o botão Atualizar é clicado. Trocar
      // só as datas já dispara o watch interno do NpsSurveyDashboard, mas
      // clicar em Atualizar com as mesmas datas não muda o computed
      // "filters" (mesma referência cacheada), então precisamos desse
      // gatilho separado para o caso de recarregar sem mudar o período.
      refreshKey: 0,
      refreshing: false
    };
  },
  computed: {
    filters() {
      return { startDate: this.dateStart, endDate: this.dateEnd };
    }
  },
  methods: {
    refreshReport() {
      this.refreshing = true;
      this.refreshKey++;
      // apenas feedback visual do botão; o remount do <nps-survey-dashboard>
      // acima já dispara o carregamento real dos dados
      setTimeout(() => { this.refreshing = false; }, 500);
    }
  }
};
</script>

<style scoped>
.rn-root {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.rn-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.rn-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.rn-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #00a884, #00c49a);
  display: flex;
  align-items: center;
  justify-content: center;
}

.rn-header-icon i {
  font-size: 18px;
  color: #fff;
}

.rn-title {
  font-size: 16px;
  font-weight: 700;
  color: #111b21;
  margin: 0;
  line-height: 1.2;
}

.rn-subtitle {
  font-size: 12px;
  color: #adb5bd;
  margin: 0;
  margin-top: 2px;
}

.rn-date-range {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8f9fa;
  border: 1.5px solid #e9edef;
  border-radius: 8px !important;
  padding: 0 10px;
  height: 36px;
}

.rn-date-label {
  font-size: 11px;
  font-weight: 600;
  color: #adb5bd;
  white-space: nowrap;
}

.rn-date-input {
  height: 28px;
  padding: 0 4px;
  border: none;
  background: transparent;
  font-size: 13px;
  color: #111b21;
  outline: none;
}

.rn-date-input:focus {
  color: #00a884;
}

/* ---------- Botão atualizar ---------- */

.sc-refresh-btn {
  height: 40px;
  padding: 0 16px;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  transition: border-color .15s, color .15s, background .15s;
}

.sc-refresh-btn:hover:not(:disabled) {
  border-color: #00a884;
  color: #00a884;
  background: #f6fffb;
}

.sc-refresh-btn:disabled {
  opacity: .45;
  cursor: not-allowed;
}

.sc-refresh-btn--spinning i {
  animation: sc-spin .5s linear;
}

@keyframes sc-spin {
  to {
    transform: rotate(360deg);
  }
}

.sc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px 20px;
  background: #fff;
  border: 1px solid #e9edef;
  border-radius: 16px;
  text-align: center;
}

.sc-empty-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #f0fdf4;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.sc-empty-icon-wrap i {
  font-size: 28px;
  color: #00a884;
}

.sc-empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #343a40;
  margin: 0 0 6px;
}

.sc-empty-sub {
  font-size: 13px;
  color: #adb5bd;
  margin: 0;
  max-width: 340px;
  line-height: 1.5;
}

.sc-report-wrap {
  background: #fff;
  border: 1px solid #e9edef;
  border-radius: 16px;
  overflow: hidden;
}
</style>